'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { connect } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Scopes } from 'AdsUI/lib/Scopes';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import { openEventPanel } from 'AdsUI/actions/EventSettingsActions';
import { isAnyAccountConnected } from '../../selectors/AccountsSelectors';

const CreateEventButton = ({
  accountConnected,
  openEventPanel: onOpenEventPanel,
  isInDropdown = false
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: /*#__PURE__*/_jsx(ScopeWrapper, {
    tooltipKey: "createEvents",
    orScopes: [Scopes.ADS_DEMO_ACCESS, Scopes.ADS_WRITE],
    children: /*#__PURE__*/_jsx(UIButton, {
      disabled: !accountConnected,
      use: "secondary",
      onClick: onOpenEventPanel,
      "data-test-id": "create-event-button",
      size: "small",
      children: isInDropdown ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createDropdown.event"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createEventButton"
      })
    })
  })
});

export default connect(state => ({
  accountConnected: isAnyAccountConnected(state)
}), {
  openEventPanel
})(CreateEventButton);